<template>
  <DetailLayout fallback-path="/pwzrList">
    <header>
      <title>转让保健食品批文_免费转让批准文号_{{ detail.titile }}</title>
      <meta name="keywords" content="{{ detail.zyyl }}"> 
      <meta name="description" content="{{ detail.bjgn }}+{{ detail.bjgn }}+{{ detail.bzxcfjhl }}"> 
    </header>
    <div class="detail-page">
      <div v-if="loading" class="loading">
        <i class="fas fa-spinner"></i> 正在加载批文详情...
      </div>
      
      <div v-else class="main-content">
        <div class="detail-container">
          <div class="detail-header">
            <h2 class="detail-title">{{ detail.titile }}</h2>
            <div v-if="detail.cbbj" class="detail-price">初步报价: {{ detail.cbbj }}</div>
          </div>
          
          <div class="detail-info">
            <div class="info-card">
              <h4><i class="fas fa-file-medical"></i> 批文基本信息</h4>
              <p v-if="detail.productName"><strong>产品名称:</strong> {{ detail.productName }}</p>
              <p v-if="detail.sbdw"><strong>申报单位:</strong> {{ detail.sbdw }}</p>
              <p v-if="detail.pzwh"><strong>批准文号:</strong> {{ detail.pzwh }}</p>
              <p v-if="detail.syrq"><strong>适宜人群:</strong> {{ detail.syrq }}</p>
              <p v-if="detail.bsyrq"><strong>不适宜人群:</strong> {{ detail.bsyrq }}</p>
              <p v-if="detail.jx"><strong>剂型:</strong> {{ detail.jx }}</p>
              <p v-if="detail.type"><strong>类型:</strong> {{ detail.type === '1' ? '出售' : '购买' }}</p>
              <p v-if="detail.status"><strong>状态:</strong> {{ detail.status === '4' ? '已发布' : '申请中' }}</p>
            </div>
            
            <div class="info-card">
              <h4><i class="fas fa-flask"></i> 产品信息</h4>
              <p v-if="detail.zyyl"><strong>主要原料:</strong> {{ detail.zyyl }}</p>
              <p v-if="detail.gg"><strong>规格:</strong> {{ detail.gg }}</p>
              <p v-if="detail.bjgn"><strong>保健功能:</strong> {{ detail.bjgn }}</p>
            </div>
            
            <div v-if="detail.bzxcfjhl" class="info-card">
              <h4><i class="fas fa-pills"></i> 成分信息</h4>
              <p><strong>标志性成分及含量:</strong> {{ detail.bzxcfjhl }}</p>
            </div>
            
            <div v-if="detail.syljsyff" class="info-card">
              <h4><i class="fas fa-utensils"></i> 使用方法</h4>
              <p><strong>食用量及食用方法:</strong> {{ detail.syljsyff }}</p>
            </div>
            
            <div v-if="detail.qtsm" class="info-card">
              <h4><i class="fas fa-info-circle"></i> 其他说明</h4>
              <p>{{ detail.qtsm }}</p>
            </div>
          </div>
        </div>
        
        <RankList :rankings="rankings" />
      </div>
    </div>
  </DetailLayout>
</template>

<script setup>
import config from '../config.js'
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'
import RankList from '@/components/RankList.vue'
import DetailLayout from './DetailLayout.vue'
import { getDeviceId } from '../utils/fingerprint.js'
import { reportBrowse } from '../api/share.js'

const route = useRoute()
const id = route.params.id

// 分享埋点：客户通过带 ?wen= 的链接进入时上报浏览（enter/heartbeat/leave）
const wen = route.query.wen || ''
let deviceId = ''
let heartbeatTimer = null

const detail = ref({})
const rankings = ref([])
const loading = ref(true)

const fetchDetail = async () => {
  try {
    loading.value = true
    const response = await axios.get(`${config.API_BASE_URL}/api/show/selectById?id=${id}`)
    console.log(response.data.data);
    detail.value = response.data.data;
  } catch (error) {
    console.error('获取批文详情失败:', error)
  } finally {
    loading.value = false
  }
}

const fetchRankings = async () => {
  try {
    const response = await axios.get(`${config.API_BASE_URL}/api/show/getRankList`)
    rankings.value = response.data.data.aaData;
  } catch (error) {
    console.error('获取排行榜失败:', error)
  }
}

onMounted(() => {
  fetchDetail()
  fetchRankings()
  // 分享埋点：仅在带 wen 参数时触发
  if (wen) {
    deviceId = getDeviceId()
    doBrowse('enter')
    heartbeatTimer = setInterval(() => doBrowse('heartbeat'), 30000)
    window.addEventListener('pagehide', handleLeave)
    document.addEventListener('visibilitychange', handleVisibility)
  }
})

onBeforeUnmount(() => {
  window.removeEventListener('pagehide', handleLeave)
  document.removeEventListener('visibilitychange', handleVisibility)
  handleLeave()
})

function doBrowse(event) {
  reportBrowse({ shareCode: wen, showId: id, deviceId, event, duration: 0 }).catch(() => {})
}

function handleLeave() {
  if (heartbeatTimer) {
    clearInterval(heartbeatTimer)
    heartbeatTimer = null
  }
  doBrowse('leave')
}

function handleVisibility() {
  if (document.visibilityState === 'hidden') {
    handleLeave()
  }
}
</script>

<style scoped>
.detail-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.main-content {
  display: flex;
  gap: 30px;
}

.detail-container {
  flex: 3;
  background: white;
  border-radius: 12px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  padding: 30px;
  margin-bottom: 30px;
}

.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.detail-title {
  font-size: 24px;
  color: #0056b3;
}

.detail-price {
  font-size: 22px;
  color: #e74c3c;
  font-weight: bold;
}

.detail-info {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.info-card {
  background: #f9fbfd;
  border-radius: 8px;
  padding: 20px;
  border: 1px solid #eaeaea;
}

.info-card h4 {
  color: #0083c9;
  margin-bottom: 15px;
  font-size: 18px;
  display: flex;
  align-items: center;
}

.info-card h4 i {
  margin-right: 8px;
}

.info-card p {
  line-height: 1.8;
}

.loading {
  text-align: center;
  padding: 50px 0;
  color: #0083c9;
  font-size: 18px;
}

.loading i {
  animation: spin 1s linear infinite;
  margin-right: 10px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@media (max-width: 900px) {
  .main-content {
    flex-direction: column;
  }
  
  .detail-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
}
</style>
